import repository from '@/repositories/Repository'
import { generateCacheKey, getCache, setCache } from '@/util/cache'

const resource = '/stores'

export default {
  async get(storeGroup, all) {
    // キーにはAPIリクエストにかかるパラメータを含める
    const _cacheKey = generateCacheKey(resource, storeGroup, all)
    const cacheData = await getCache(_cacheKey)
    if (cacheData) {
      return cacheData
    }
    const data = await repository.bizoo
      .get(`${resource}/${storeGroup}?all=${all}`)
      .then(r => {
        setCache(_cacheKey, r.data)
        return r.data
      })
    return data
  },
}
